import { Image as Img } from 'antd';
import { preload } from "../../../assets"
import usePreloader from '../hooks/usePreloader';

const Banner = ({ img }) => {
    const { loading } = usePreloader(img)
    return (
        <Img
            className='image'
            width={"100%"}
            loading='lazy'
            height={"450px"}
            style={{
                objectFit: "cover",
                position: "relative",
                objectPosition: "top",
            }}
            src={loading ? preload : img}
            rootClassName={`Banner PortfolioBanner`}
        />

    );
}

export default Banner;